module.exports = __webpack_public_path__ + "static/media/Mat_rhino_normal.418c1ab8.png";